// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from "./client"
import { client } from "./client.gen"
import type {
  AcquireTeamReviewLockData,
  AcquireTeamReviewLockErrors,
  AcquireTeamReviewLockResponses,
  AddLateAuthorData,
  AddLateAuthorErrors,
  AddLateAuthorResponses,
  AddLtiDeploymentData,
  AddLtiDeploymentErrors,
  AddLtiDeploymentResponses,
  AddTeamMemberData,
  AddTeamMemberErrors,
  AddTeamMemberResponses,
  AdjustJoinCodeData,
  AdjustJoinCodeErrors,
  AdjustJoinCodeResponses,
  AdjustSectionJoinCodeData,
  AdjustSectionJoinCodeErrors,
  AdjustSectionJoinCodeResponses,
  AdminEnrollMockStudentsData,
  AdminEnrollMockStudentsErrors,
  AdminEnrollMockStudentsResponses,
  ArchiveSectionData,
  ArchiveSectionErrors,
  ArchiveSectionResponses,
  AssignLateJoinerData,
  AssignLateJoinerErrors,
  AssignLateJoinerResponses,
  AssignLateJoinerTeamData,
  AssignLateJoinerTeamErrors,
  AssignLateJoinerTeamResponses,
  BulkAddTeamMembersData,
  BulkAddTeamMembersErrors,
  BulkAddTeamMembersResponses,
  BulkEnrollUsersData,
  BulkEnrollUsersErrors,
  BulkEnrollUsersResponses,
  BulkRemoveTeamMembersData,
  BulkRemoveTeamMembersErrors,
  BulkRemoveTeamMembersResponses,
  BulkUnenrollUsersData,
  BulkUnenrollUsersErrors,
  BulkUnenrollUsersResponses,
  ClearJoinCodeData,
  ClearJoinCodeErrors,
  ClearJoinCodeResponses,
  ClearSectionJoinCodeData,
  ClearSectionJoinCodeErrors,
  ClearSectionJoinCodeResponses,
  CloseAssignmentData,
  CloseAssignmentErrors,
  CloseAssignmentResponses,
  ConfirmSignupData,
  ConfirmSignupErrors,
  ConfirmSignupResponses,
  CreateApiKeyData,
  CreateApiKeyErrors,
  CreateApiKeyResponses,
  CreateAssignmentData,
  CreateAssignmentErrors,
  CreateAssignmentResponses,
  CreateCourseData,
  CreateCourseErrors,
  CreateCourseResponses,
  CreateLtiClientConfigData,
  CreateLtiClientConfigErrors,
  CreateLtiClientConfigResponses,
  CreateLtiIssuerData,
  CreateLtiIssuerErrors,
  CreateLtiIssuerResponses,
  CreateLtiToolKeyData,
  CreateLtiToolKeyErrors,
  CreateLtiToolKeyResponses,
  CreateProjectData,
  CreateProjectErrors,
  CreateProjectResponses,
  CreateRubricData,
  CreateRubricErrors,
  CreateRubricItemData,
  CreateRubricItemErrors,
  CreateRubricItemOptionData,
  CreateRubricItemOptionErrors,
  CreateRubricItemOptionResponses,
  CreateRubricItemResponses,
  CreateRubricResponses,
  CreateRubricV2Data,
  CreateRubricV2Errors,
  CreateRubricV2Responses,
  CreateSectionData,
  CreateSectionErrors,
  CreateSectionResponses,
  CreateTeamData,
  CreateTeamErrors,
  CreateTeamGroupData,
  CreateTeamGroupErrors,
  CreateTeamGroupResponses,
  CreateTeamResponses,
  CreateUserData,
  CreateUserErrors,
  CreateUserResponses,
  DeleteApiKeyData,
  DeleteApiKeyErrors,
  DeleteApiKeyResponses,
  DeleteAssignmentData,
  DeleteAssignmentErrors,
  DeleteAssignmentResponses,
  DeleteCourseData,
  DeleteCourseErrors,
  DeleteCourseResponses,
  DeleteLtiClientConfigData,
  DeleteLtiClientConfigErrors,
  DeleteLtiClientConfigResponses,
  DeleteLtiIssuerData,
  DeleteLtiIssuerErrors,
  DeleteLtiIssuerResponses,
  DeleteLtiToolKeyData,
  DeleteLtiToolKeyErrors,
  DeleteLtiToolKeyResponses,
  DeleteProjectData,
  DeleteProjectErrors,
  DeleteProjectResponses,
  DeleteRubricData,
  DeleteRubricErrors,
  DeleteRubricItemData,
  DeleteRubricItemErrors,
  DeleteRubricItemOptionData,
  DeleteRubricItemOptionErrors,
  DeleteRubricItemOptionResponses,
  DeleteRubricItemResponses,
  DeleteRubricResponses,
  DeleteTeamData,
  DeleteTeamErrors,
  DeleteTeamGroupData,
  DeleteTeamGroupErrors,
  DeleteTeamGroupResponses,
  DeleteTeamResponses,
  DeleteUserData,
  DeleteUserErrors,
  DeleteUserResponses,
  EnrollUserData,
  EnrollUserErrors,
  EnrollUserResponses,
  ExportAssignmentAllocationsData,
  ExportAssignmentAllocationsErrors,
  ExportAssignmentAllocationsResponses,
  ExportAssignmentReviewsData,
  ExportAssignmentReviewsErrors,
  ExportAssignmentReviewsResponses,
  ExportAssignmentScoresData,
  ExportAssignmentScoresErrors,
  ExportAssignmentScoresResponses,
  ExportGradebookData,
  ExportGradebookErrors,
  ExportGradebookResponses,
  ExportRosterData,
  ExportRosterErrors,
  ExportRosterResponses,
  GenerateJoinCodeData,
  GenerateJoinCodeErrors,
  GenerateJoinCodeResponses,
  GenerateSectionJoinCodeData,
  GenerateSectionJoinCodeErrors,
  GenerateSectionJoinCodeResponses,
  GetAssignmentData,
  GetAssignmentErrors,
  GetAssignmentResponses,
  GetAssignmentScoringConfigData,
  GetAssignmentScoringConfigErrors,
  GetAssignmentScoringConfigResponses,
  GetAssignmentSummaryData,
  GetAssignmentSummaryErrors,
  GetAssignmentSummaryResponses,
  GetCourseData,
  GetCourseErrors,
  GetCourseResponses,
  GetCourseSummaryData,
  GetCourseSummaryErrors,
  GetCourseSummaryResponses,
  GetCurrentUserData,
  GetCurrentUserErrors,
  GetCurrentUserResponses,
  GetInstructorDashboardData,
  GetInstructorDashboardErrors,
  GetInstructorDashboardResponses,
  GetJoinCodeData,
  GetJoinCodeErrors,
  GetJoinCodeResponses,
  GetJwksData,
  GetJwksResponses,
  GetLtiClientConfigData,
  GetLtiClientConfigErrors,
  GetLtiClientConfigResponses,
  GetLtiIssuerData,
  GetLtiIssuerErrors,
  GetLtiIssuerResponses,
  GetLtiLaunchContextData,
  GetLtiLaunchContextErrors,
  GetLtiLaunchContextResponses,
  GetLtiToolKeyData,
  GetLtiToolKeyErrors,
  GetLtiToolKeyResponses,
  GetMyPublishedAssignmentScoreData,
  GetMyPublishedAssignmentScoreErrors,
  GetMyPublishedAssignmentScoreResponses,
  GetProjectData,
  GetProjectErrors,
  GetProjectResponses,
  GetProjectReviewSummaryData,
  GetProjectReviewSummaryErrors,
  GetProjectReviewSummaryResponses,
  GetPublishedAssignmentScoreData,
  GetPublishedAssignmentScoreErrors,
  GetPublishedAssignmentScoreResponses,
  GetReviewDraftData,
  GetReviewDraftErrors,
  GetReviewDraftResponses,
  GetRevieweeScoreData,
  GetRevieweeScoreErrors,
  GetRevieweeScoreResponses,
  GetRevieweeTeamScoreData,
  GetRevieweeTeamScoreErrors,
  GetRevieweeTeamScoreResponses,
  GetReviewerParticipationData,
  GetReviewerParticipationErrors,
  GetReviewerParticipationResponses,
  GetReviewerTeamParticipationData,
  GetReviewerTeamParticipationErrors,
  GetReviewerTeamParticipationResponses,
  GetRubricData,
  GetRubricErrors,
  GetRubricResponses,
  GetSectionData,
  GetSectionErrors,
  GetSectionJoinCodeData,
  GetSectionJoinCodeErrors,
  GetSectionJoinCodeResponses,
  GetSectionResponses,
  GetStudentDashboardData,
  GetStudentDashboardErrors,
  GetStudentDashboardResponses,
  GetUserData,
  GetUserErrors,
  GetUserResponses,
  HealthCheckData,
  HealthCheckHeadData,
  HealthCheckHeadResponses,
  HealthCheckResponses,
  ImportRosterData,
  ImportRosterErrors,
  ImportRosterResponses,
  JoinCourseData,
  JoinCourseErrors,
  JoinCourseResponses,
  ListAllocationsData,
  ListAllocationsErrors,
  ListAllocationsResponses,
  ListAssignmentsData,
  ListAssignmentsErrors,
  ListAssignmentsResponses,
  ListCoursePublishedScoresData,
  ListCoursePublishedScoresErrors,
  ListCoursePublishedScoresResponses,
  ListCoursesData,
  ListCoursesErrors,
  ListCoursesResponses,
  ListEnrollmentsData,
  ListEnrollmentsErrors,
  ListEnrollmentsResponses,
  ListLtiClientConfigsData,
  ListLtiClientConfigsErrors,
  ListLtiClientConfigsResponses,
  ListLtiDeploymentsData,
  ListLtiDeploymentsErrors,
  ListLtiDeploymentsResponses,
  ListLtiIssuersData,
  ListLtiIssuersErrors,
  ListLtiIssuersResponses,
  ListLtiToolKeysData,
  ListLtiToolKeysErrors,
  ListLtiToolKeysResponses,
  ListMembersData,
  ListMembersErrors,
  ListMembersResponses,
  ListMyAllocationsData,
  ListMyAllocationsErrors,
  ListMyAllocationsResponses,
  ListMyReceivedReviewsData,
  ListMyReceivedReviewsErrors,
  ListMyReceivedReviewsResponses,
  ListMyWrittenReviewsData,
  ListMyWrittenReviewsErrors,
  ListMyWrittenReviewsResponses,
  ListProjectsData,
  ListProjectsErrors,
  ListProjectsResponses,
  ListPublishedAssignmentScoresData,
  ListPublishedAssignmentScoresErrors,
  ListPublishedAssignmentScoresResponses,
  ListReviewsData,
  ListReviewsErrors,
  ListReviewsResponses,
  ListRubricItemOptionsData,
  ListRubricItemOptionsErrors,
  ListRubricItemOptionsResponses,
  ListRubricItemsData,
  ListRubricItemsErrors,
  ListRubricItemsResponses,
  ListRubricsData,
  ListRubricsErrors,
  ListRubricsResponses,
  ListRubricsV2Data,
  ListRubricsV2Errors,
  ListRubricsV2Responses,
  ListSectionAssignmentsData,
  ListSectionAssignmentsErrors,
  ListSectionAssignmentsResponses,
  ListSectionEnrollmentsData,
  ListSectionEnrollmentsErrors,
  ListSectionEnrollmentsResponses,
  ListSectionProjectsData,
  ListSectionProjectsErrors,
  ListSectionProjectsResponses,
  ListSectionsData,
  ListSectionsErrors,
  ListSectionsResponses,
  ListTeamAllocationsData,
  ListTeamAllocationsErrors,
  ListTeamAllocationsResponses,
  ListTeamGroupsData,
  ListTeamGroupsErrors,
  ListTeamGroupsResponses,
  ListTeamsData,
  ListTeamsErrors,
  ListTeamsResponses,
  ListUserRubricTemplatesData,
  ListUserRubricTemplatesErrors,
  ListUserRubricTemplatesResponses,
  LoginData,
  LoginErrors,
  LoginResponses,
  LogoutData,
  LogoutResponses,
  LtiDeepLinkPayloadData,
  LtiDeepLinkPayloadErrors,
  LtiDeepLinkPayloadResponses,
  LtiDynamicRegistrationData,
  LtiDynamicRegistrationErrors,
  LtiDynamicRegistrationResponses,
  LtiGradeSyncData,
  LtiGradeSyncErrors,
  LtiGradeSyncResponses,
  LtiLaunchData,
  LtiLaunchErrors,
  LtiLaunchResponses,
  LtiLoginGetData,
  LtiLoginGetErrors,
  LtiLoginGetResponses,
  LtiLoginPostData,
  LtiLoginPostErrors,
  LtiLoginPostResponses,
  LtiRosterSyncData,
  LtiRosterSyncErrors,
  LtiRosterSyncResponses,
  OpenAssignmentData,
  OpenAssignmentErrors,
  OpenAssignmentResponses,
  PreviewAssignmentScoresData,
  PreviewAssignmentScoresErrors,
  PreviewAssignmentScoresResponses,
  PublishAssignmentData,
  PublishAssignmentErrors,
  PublishAssignmentResponses,
  ReadRootData,
  ReadRootHeadData,
  ReadRootHeadResponses,
  ReadRootResponses,
  RecommendExtraTargetsData,
  RecommendExtraTargetsErrors,
  RecommendExtraTargetsForReviewerTeamData,
  RecommendExtraTargetsForReviewerTeamErrors,
  RecommendExtraTargetsForReviewerTeamResponses,
  RecommendExtraTargetsResponses,
  ReleaseTeamReviewLockData,
  ReleaseTeamReviewLockErrors,
  ReleaseTeamReviewLockResponses,
  RemoveLtiDeploymentData,
  RemoveLtiDeploymentErrors,
  RemoveLtiDeploymentResponses,
  RemoveTeamMemberData,
  RemoveTeamMemberErrors,
  RemoveTeamMemberResponses,
  RenameSectionData,
  RenameSectionErrors,
  RenameSectionResponses,
  ReorderRubricItemOptionsData,
  ReorderRubricItemOptionsErrors,
  ReorderRubricItemOptionsResponses,
  ReorderRubricItemsData,
  ReorderRubricItemsErrors,
  ReorderRubricItemsResponses,
  ReplaceRubricData,
  ReplaceRubricErrors,
  ReplaceRubricResponses,
  ResetPasswordData,
  ResetPasswordErrors,
  ResetPasswordResponses,
  RotateJoinCodeData,
  RotateJoinCodeErrors,
  RotateJoinCodeResponses,
  RotateSectionJoinCodeData,
  RotateSectionJoinCodeErrors,
  RotateSectionJoinCodeResponses,
  SaveReviewDraftData,
  SaveReviewDraftErrors,
  SaveReviewDraftResponses,
  SaveTeamReviewDraftData,
  SaveTeamReviewDraftErrors,
  SaveTeamReviewDraftResponses,
  SignupData,
  SignupErrors,
  SignupResponses,
  SubmitReviewData,
  SubmitReviewErrors,
  SubmitReviewResponses,
  SubmitStaffReviewData,
  SubmitStaffReviewErrors,
  SubmitStaffReviewResponses,
  SubmitTeamReviewData,
  SubmitTeamReviewErrors,
  SubmitTeamReviewResponses,
  UnenrollUserData,
  UnenrollUserErrors,
  UnenrollUserResponses,
  UnsubmitTeamReviewData,
  UnsubmitTeamReviewErrors,
  UnsubmitTeamReviewResponses,
  UpdateAssignmentData,
  UpdateAssignmentErrors,
  UpdateAssignmentResponses,
  UpdateAssignmentScoringConfigData,
  UpdateAssignmentScoringConfigErrors,
  UpdateAssignmentScoringConfigResponses,
  UpdateCourseData,
  UpdateCourseErrors,
  UpdateCourseResponses,
  UpdateEnrollmentData,
  UpdateEnrollmentErrors,
  UpdateEnrollmentResponses,
  UpdateLtiClientConfigData,
  UpdateLtiClientConfigErrors,
  UpdateLtiClientConfigResponses,
  UpdateLtiIssuerData,
  UpdateLtiIssuerErrors,
  UpdateLtiIssuerResponses,
  UpdateLtiToolKeyData,
  UpdateLtiToolKeyErrors,
  UpdateLtiToolKeyResponses,
  UpdateProjectData,
  UpdateProjectErrors,
  UpdateProjectResponses,
  UpdateRubricData,
  UpdateRubricErrors,
  UpdateRubricItemData,
  UpdateRubricItemErrors,
  UpdateRubricItemOptionData,
  UpdateRubricItemOptionErrors,
  UpdateRubricItemOptionResponses,
  UpdateRubricItemResponses,
  UpdateRubricResponses,
  UpdateTeamData,
  UpdateTeamErrors,
  UpdateTeamGroupData,
  UpdateTeamGroupErrors,
  UpdateTeamGroupResponses,
  UpdateTeamResponses,
  UpdateUserData,
  UpdateUserErrors,
  UpdateUserResponses,
} from "./types.gen"

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * Read Root
 *
 * Temporary root route to redirect to the docs.
 */
export const readRoot = <ThrowOnError extends boolean = false>(options?: Options<ReadRootData, ThrowOnError>) =>
  (options?.client ?? client).get<ReadRootResponses, unknown, ThrowOnError>({ url: "/", ...options })

/**
 * Read Root
 *
 * Temporary root route to redirect to the docs.
 */
export const readRootHead = <ThrowOnError extends boolean = false>(options?: Options<ReadRootHeadData, ThrowOnError>) =>
  (options?.client ?? client).head<ReadRootHeadResponses, unknown, ThrowOnError>({ url: "/", ...options })

/**
 * Health
 *
 * Return a simple service health indicator.
 */
export const healthCheck = <ThrowOnError extends boolean = false>(options?: Options<HealthCheckData, ThrowOnError>) =>
  (options?.client ?? client).get<HealthCheckResponses, unknown, ThrowOnError>({ url: "/health", ...options })

/**
 * Health
 *
 * Return a simple service health indicator.
 */
export const healthCheckHead = <ThrowOnError extends boolean = false>(
  options?: Options<HealthCheckHeadData, ThrowOnError>,
) => (options?.client ?? client).head<HealthCheckHeadResponses, unknown, ThrowOnError>({ url: "/health", ...options })

/**
 * Create User
 *
 * Create a new user and return the persisted record. Requires admin role.
 */
export const createUser = <ThrowOnError extends boolean = false>(options: Options<CreateUserData, ThrowOnError>) =>
  (options.client ?? client).post<CreateUserResponses, CreateUserErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/users/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Get Current User Info
 *
 * Retrieve the current authenticated user's information.
 */
export const getCurrentUser = <ThrowOnError extends boolean = false>(
  options?: Options<GetCurrentUserData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCurrentUserResponses, GetCurrentUserErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/users/me",
    ...options,
  })

/**
 * Delete User
 *
 * Delete a user by identifier.
 */
export const deleteUser = <ThrowOnError extends boolean = false>(options: Options<DeleteUserData, ThrowOnError>) =>
  (options.client ?? client).delete<DeleteUserResponses, DeleteUserErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/users/{user_id}",
    ...options,
  })

/**
 * Get User
 *
 * Retrieve a user by identifier.
 */
export const getUser = <ThrowOnError extends boolean = false>(options: Options<GetUserData, ThrowOnError>) =>
  (options.client ?? client).get<GetUserResponses, GetUserErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/users/{user_id}",
    ...options,
  })

/**
 * Update User
 *
 * Apply partial updates to an existing user. Must be authenticated.
 */
export const updateUser = <ThrowOnError extends boolean = false>(options: Options<UpdateUserData, ThrowOnError>) =>
  (options.client ?? client).patch<UpdateUserResponses, UpdateUserErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/users/{user_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Login
 *
 * Start OIDC login. LMS calls this with target_link_uri=<your launch URL>.
 */
export const ltiLoginGet = <ThrowOnError extends boolean = false>(options?: Options<LtiLoginGetData, ThrowOnError>) =>
  (options?.client ?? client).get<LtiLoginGetResponses, LtiLoginGetErrors, ThrowOnError>({
    url: "/lti/login/",
    ...options,
  })

/**
 * Login
 *
 * Start OIDC login. LMS calls this with target_link_uri=<your launch URL>.
 */
export const ltiLoginPost = <ThrowOnError extends boolean = false>(options?: Options<LtiLoginPostData, ThrowOnError>) =>
  (options?.client ?? client).post<LtiLoginPostResponses, LtiLoginPostErrors, ThrowOnError>({
    url: "/lti/login/",
    ...options,
  })

/**
 * Launch
 *
 * LTI message launch. Validates the id_token and issues a backend session before redirecting.
 */
export const ltiLaunch = <ThrowOnError extends boolean = false>(options?: Options<LtiLaunchData, ThrowOnError>) =>
  (options?.client ?? client).post<LtiLaunchResponses, LtiLaunchErrors, ThrowOnError>({
    url: "/lti/launch/",
    ...options,
  })

/**
 * Deep Link Payload
 *
 * Build a Deep Linking response and return an auto-submitting LMS return form.
 *
 * The successful response is HTML, not JSON. The frontend must render it as the current browser document so the
 * generated form POST is submitted by the user agent, preserving the browser-mediated LTI return flow.
 */
export const ltiDeepLinkPayload = <ThrowOnError extends boolean = false>(
  options: Options<LtiDeepLinkPayloadData, ThrowOnError>,
) =>
  (options.client ?? client).post<LtiDeepLinkPayloadResponses, LtiDeepLinkPayloadErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/lti/deep-link/payload",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Get Launch Context
 *
 * Retrieve frontend-safe bootstrap context from a short-lived server-side launch context store.
 */
export const getLtiLaunchContext = <ThrowOnError extends boolean = false>(
  options: Options<GetLtiLaunchContextData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetLtiLaunchContextResponses, GetLtiLaunchContextErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/lti/launch-context/{context_id}",
    ...options,
  })

/**
 * Jwks
 *
 * Expose the tool's JWKS (public keys) from persisted configuration.
 */
export const getJwks = <ThrowOnError extends boolean = false>(options?: Options<GetJwksData, ThrowOnError>) =>
  (options?.client ?? client).get<GetJwksResponses, unknown, ThrowOnError>({ url: "/lti/jwks/", ...options })

/**
 * Dynamic Registration
 *
 * Register this tool dynamically against an LTI Advantage platform.
 */
export const ltiDynamicRegistration = <ThrowOnError extends boolean = false>(
  options: Options<LtiDynamicRegistrationData, ThrowOnError>,
) =>
  (options.client ?? client).post<LtiDynamicRegistrationResponses, LtiDynamicRegistrationErrors, ThrowOnError>({
    url: "/lti/dynamic-registration",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Roster Sync
 *
 * Sync the LMS roster into a section using a persisted NRPS context link.
 */
export const ltiRosterSync = <ThrowOnError extends boolean = false>(
  options: Options<LtiRosterSyncData, ThrowOnError>,
) =>
  (options.client ?? client).post<LtiRosterSyncResponses, LtiRosterSyncErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/lti/roster-sync",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Grade Sync
 *
 * Sync assignment published scores to LMS line items using a persisted AGS context link.
 */
export const ltiGradeSync = <ThrowOnError extends boolean = false>(options: Options<LtiGradeSyncData, ThrowOnError>) =>
  (options.client ?? client).post<LtiGradeSyncResponses, LtiGradeSyncErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/lti/grade-sync",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Signup
 *
 * Registers a new user with Supabase.
 *
 * Sends a confirmation email via Supabase to the provided email address.
 */
export const signup = <ThrowOnError extends boolean = false>(options: Options<SignupData, ThrowOnError>) =>
  (options.client ?? client).post<SignupResponses, SignupErrors, ThrowOnError>({
    url: "/auth/signup",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Confirm Signup
 *
 * Confirms the signup originating from Supabase email and redirects to the frontend.
 *
 * This is a GET endpoint because it is intended to be called from a link in an email.
 * The confirmation token is one-time use and expires after verification.
 */
export const confirmSignup = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmSignupData, ThrowOnError>,
) =>
  (options.client ?? client).get<ConfirmSignupResponses, ConfirmSignupErrors, ThrowOnError>({
    url: "/auth/confirm",
    ...options,
  })

/**
 * Login
 *
 * Authenticate a user with Supabase and issue a session cookie.
 */
export const login = <ThrowOnError extends boolean = false>(options: Options<LoginData, ThrowOnError>) =>
  (options.client ?? client).post<LoginResponses, LoginErrors, ThrowOnError>({
    url: "/auth/login",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Reset Password
 *
 * Send password reset instructions via Supabase for the provided email.
 */
export const resetPassword = <ThrowOnError extends boolean = false>(
  options: Options<ResetPasswordData, ThrowOnError>,
) =>
  (options.client ?? client).post<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({
    url: "/auth/reset-password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Logout
 *
 * Revoke the caller's session cookie if present.
 */
export const logout = <ThrowOnError extends boolean = false>(options?: Options<LogoutData, ThrowOnError>) =>
  (options?.client ?? client).post<LogoutResponses, unknown, ThrowOnError>({ url: "/auth/logout", ...options })

/**
 * Delete Api Key
 *
 * Delete the current user's API key.
 */
export const deleteApiKey = <ThrowOnError extends boolean = false>(options?: Options<DeleteApiKeyData, ThrowOnError>) =>
  (options?.client ?? client).delete<DeleteApiKeyResponses, DeleteApiKeyErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/auth/api-key",
    ...options,
  })

/**
 * Create Api Key
 *
 * Create an API key for the current user.
 */
export const createApiKey = <ThrowOnError extends boolean = false>(options?: Options<CreateApiKeyData, ThrowOnError>) =>
  (options?.client ?? client).post<CreateApiKeyResponses, CreateApiKeyErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/auth/api-key",
    ...options,
  })

/**
 * List Courses
 *
 * List courses visible to the current user.
 */
export const listCourses = <ThrowOnError extends boolean = false>(options?: Options<ListCoursesData, ThrowOnError>) =>
  (options?.client ?? client).get<ListCoursesResponses, ListCoursesErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses",
    ...options,
  })

/**
 * Create Course
 *
 * Create a new course.
 *
 * If owner_id is provided, it must match the current user's ID or the user must be an admin.
 * If owner_id is not provided, the course will be owned by the current user.
 */
export const createCourse = <ThrowOnError extends boolean = false>(options: Options<CreateCourseData, ThrowOnError>) =>
  (options.client ?? client).post<CreateCourseResponses, CreateCourseErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Delete Course
 *
 * Delete a course permanently.
 */
export const deleteCourse = <ThrowOnError extends boolean = false>(options: Options<DeleteCourseData, ThrowOnError>) =>
  (options.client ?? client).delete<DeleteCourseResponses, DeleteCourseErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}",
    ...options,
  })

/**
 * Get Course
 *
 * Retrieve detailed information for a course.
 */
export const getCourse = <ThrowOnError extends boolean = false>(options: Options<GetCourseData, ThrowOnError>) =>
  (options.client ?? client).get<GetCourseResponses, GetCourseErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}",
    ...options,
  })

/**
 * Update Course
 *
 * Apply partial updates to a course.
 *
 * Only admins or the current course owner can update the owner_id field.
 */
export const updateCourse = <ThrowOnError extends boolean = false>(options: Options<UpdateCourseData, ThrowOnError>) =>
  (options.client ?? client).patch<UpdateCourseResponses, UpdateCourseErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Clear Join Code
 *
 * Remove the join code from a course.
 */
export const clearJoinCode = <ThrowOnError extends boolean = false>(
  options: Options<ClearJoinCodeData, ThrowOnError>,
) =>
  (options.client ?? client).delete<ClearJoinCodeResponses, ClearJoinCodeErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/join-code",
    ...options,
  })

/**
 * Get Join Code
 *
 * Retrieve the active join code for a course.
 */
export const getJoinCode = <ThrowOnError extends boolean = false>(options: Options<GetJoinCodeData, ThrowOnError>) =>
  (options.client ?? client).get<GetJoinCodeResponses, GetJoinCodeErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/join-code",
    ...options,
  })

/**
 * Adjust Join Code
 *
 * Adjust join code expiration for a course.
 */
export const adjustJoinCode = <ThrowOnError extends boolean = false>(
  options: Options<AdjustJoinCodeData, ThrowOnError>,
) =>
  (options.client ?? client).patch<AdjustJoinCodeResponses, AdjustJoinCodeErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/join-code",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Generate Join Code
 *
 * Deprecated: rotate the join code (works even when none exists).
 *
 * @deprecated
 */
export const generateJoinCode = <ThrowOnError extends boolean = false>(
  options: Options<GenerateJoinCodeData, ThrowOnError>,
) =>
  (options.client ?? client).post<GenerateJoinCodeResponses, GenerateJoinCodeErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/join-code",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Rotate Join Code
 *
 * Rotate the join code with a newly generated value (or create it if missing).
 */
export const rotateJoinCode = <ThrowOnError extends boolean = false>(
  options: Options<RotateJoinCodeData, ThrowOnError>,
) =>
  (options.client ?? client).put<RotateJoinCodeResponses, RotateJoinCodeErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/join-code",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Clear Section Join Code
 *
 * Remove the join code from a section.
 */
export const clearSectionJoinCode = <ThrowOnError extends boolean = false>(
  options: Options<ClearSectionJoinCodeData, ThrowOnError>,
) =>
  (options.client ?? client).delete<ClearSectionJoinCodeResponses, ClearSectionJoinCodeErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/sections/{section_id}/join-code",
    ...options,
  })

/**
 * Get Section Join Code
 *
 * Retrieve the active join code for a section.
 */
export const getSectionJoinCode = <ThrowOnError extends boolean = false>(
  options: Options<GetSectionJoinCodeData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetSectionJoinCodeResponses, GetSectionJoinCodeErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/sections/{section_id}/join-code",
    ...options,
  })

/**
 * Adjust Section Join Code
 *
 * Adjust join code expiration for a section.
 */
export const adjustSectionJoinCode = <ThrowOnError extends boolean = false>(
  options: Options<AdjustSectionJoinCodeData, ThrowOnError>,
) =>
  (options.client ?? client).patch<AdjustSectionJoinCodeResponses, AdjustSectionJoinCodeErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/sections/{section_id}/join-code",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Generate Section Join Code
 *
 * Deprecated: rotate the join code (works even when none exists).
 *
 * @deprecated
 */
export const generateSectionJoinCode = <ThrowOnError extends boolean = false>(
  options: Options<GenerateSectionJoinCodeData, ThrowOnError>,
) =>
  (options.client ?? client).post<GenerateSectionJoinCodeResponses, GenerateSectionJoinCodeErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/sections/{section_id}/join-code",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Rotate Section Join Code
 *
 * Rotate the join code for a section with a newly generated value (or create it if missing).
 */
export const rotateSectionJoinCode = <ThrowOnError extends boolean = false>(
  options: Options<RotateSectionJoinCodeData, ThrowOnError>,
) =>
  (options.client ?? client).put<RotateSectionJoinCodeResponses, RotateSectionJoinCodeErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/sections/{section_id}/join-code",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Join Course
 *
 * Self-enroll the current user into a course using a join code.
 */
export const joinCourse = <ThrowOnError extends boolean = false>(options: Options<JoinCourseData, ThrowOnError>) =>
  (options.client ?? client).post<JoinCourseResponses, JoinCourseErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/course-joins",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Get Sections
 *
 * List sections for a course.
 */
export const listSections = <ThrowOnError extends boolean = false>(options: Options<ListSectionsData, ThrowOnError>) =>
  (options.client ?? client).get<ListSectionsResponses, ListSectionsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/sections",
    ...options,
  })

/**
 * Create Section
 *
 * Create a new section within a course.
 */
export const createSection = <ThrowOnError extends boolean = false>(
  options: Options<CreateSectionData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateSectionResponses, CreateSectionErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/sections",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Archive Section
 *
 * Archive a course section.
 */
export const archiveSection = <ThrowOnError extends boolean = false>(
  options: Options<ArchiveSectionData, ThrowOnError>,
) =>
  (options.client ?? client).delete<ArchiveSectionResponses, ArchiveSectionErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/sections/{section_id}",
    ...options,
  })

/**
 * Get Section
 *
 * Retrieve a single section within a course.
 */
export const getSection = <ThrowOnError extends boolean = false>(options: Options<GetSectionData, ThrowOnError>) =>
  (options.client ?? client).get<GetSectionResponses, GetSectionErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/sections/{section_id}",
    ...options,
  })

/**
 * Rename Section
 *
 * Rename an existing course section.
 */
export const renameSection = <ThrowOnError extends boolean = false>(
  options: Options<RenameSectionData, ThrowOnError>,
) =>
  (options.client ?? client).patch<RenameSectionResponses, RenameSectionErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/sections/{section_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * List Team Groups
 *
 * List team groups for a course.
 */
export const listTeamGroups = <ThrowOnError extends boolean = false>(
  options: Options<ListTeamGroupsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListTeamGroupsResponses, ListTeamGroupsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/team-groups",
    ...options,
  })

/**
 * Create Team Group
 *
 * Create a new team group within a course.
 */
export const createTeamGroup = <ThrowOnError extends boolean = false>(
  options: Options<CreateTeamGroupData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateTeamGroupResponses, CreateTeamGroupErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/team-groups",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Delete Team Group
 *
 * Delete a team group from a course.
 */
export const deleteTeamGroup = <ThrowOnError extends boolean = false>(
  options: Options<DeleteTeamGroupData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteTeamGroupResponses, DeleteTeamGroupErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/team-groups/{team_group_id}",
    ...options,
  })

/**
 * Update Team Group
 *
 * Update a team group within a course.
 */
export const updateTeamGroup = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTeamGroupData, ThrowOnError>,
) =>
  (options.client ?? client).patch<UpdateTeamGroupResponses, UpdateTeamGroupErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/team-groups/{team_group_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * List Teams
 *
 * List teams in a course with optional team-group, section, and membership filters.
 */
export const listTeams = <ThrowOnError extends boolean = false>(options: Options<ListTeamsData, ThrowOnError>) =>
  (options.client ?? client).get<ListTeamsResponses, ListTeamsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/teams",
    ...options,
  })

/**
 * Create Team
 *
 * Create a team in a course.
 */
export const createTeam = <ThrowOnError extends boolean = false>(options: Options<CreateTeamData, ThrowOnError>) =>
  (options.client ?? client).post<CreateTeamResponses, CreateTeamErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/teams",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Delete Team
 *
 * Delete a team from a course.
 */
export const deleteTeam = <ThrowOnError extends boolean = false>(options: Options<DeleteTeamData, ThrowOnError>) =>
  (options.client ?? client).delete<DeleteTeamResponses, DeleteTeamErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/teams/{team_id}",
    ...options,
  })

/**
 * Update Team
 *
 * Update team attributes within a course.
 */
export const updateTeam = <ThrowOnError extends boolean = false>(options: Options<UpdateTeamData, ThrowOnError>) =>
  (options.client ?? client).patch<UpdateTeamResponses, UpdateTeamErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/teams/{team_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Add Team Member
 *
 * Add an enrolled user to a team.
 */
export const addTeamMember = <ThrowOnError extends boolean = false>(
  options: Options<AddTeamMemberData, ThrowOnError>,
) =>
  (options.client ?? client).post<AddTeamMemberResponses, AddTeamMemberErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/teams/{team_id}/members",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Bulk Add Team Members
 *
 * Add multiple enrolled users to a team in one request.
 */
export const bulkAddTeamMembers = <ThrowOnError extends boolean = false>(
  options: Options<BulkAddTeamMembersData, ThrowOnError>,
) =>
  (options.client ?? client).post<BulkAddTeamMembersResponses, BulkAddTeamMembersErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/teams/{team_id}/members/bulk-add",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Remove Team Member
 *
 * Remove an enrolled user from a team.
 */
export const removeTeamMember = <ThrowOnError extends boolean = false>(
  options: Options<RemoveTeamMemberData, ThrowOnError>,
) =>
  (options.client ?? client).delete<RemoveTeamMemberResponses, RemoveTeamMemberErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/teams/{team_id}/members/{user_id}",
    ...options,
  })

/**
 * Bulk Remove Team Members
 *
 * Remove multiple enrolled users from a team in one request.
 */
export const bulkRemoveTeamMembers = <ThrowOnError extends boolean = false>(
  options: Options<BulkRemoveTeamMembersData, ThrowOnError>,
) =>
  (options.client ?? client).post<BulkRemoveTeamMembersResponses, BulkRemoveTeamMembersErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/teams/{team_id}/members/bulk-remove",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * List Section Assignments
 *
 * List assignments visible for a section.
 *
 * Returns all assignments for the section's course.
 */
export const listSectionAssignments = <ThrowOnError extends boolean = false>(
  options: Options<ListSectionAssignmentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListSectionAssignmentsResponses, ListSectionAssignmentsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/sections/{section_id}/assignments",
    ...options,
  })

/**
 * List Section Projects
 *
 * List projects for the section's course.
 *
 * Projects belong to courses rather than sections, so this returns all projects
 * for the course that contains this section.
 */
export const listSectionProjects = <ThrowOnError extends boolean = false>(
  options: Options<ListSectionProjectsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListSectionProjectsResponses, ListSectionProjectsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/sections/{section_id}/projects",
    ...options,
  })

/**
 * List Members
 *
 * List course members with member-tab fields.
 *
 * This endpoint is a roster projection for UI consumption and includes team,
 * permission-filtered email, and review progress values. For canonical
 * enrollment records (without member projection fields), use
 * ``GET /courses/{course_id}/enrollments`` or
 * ``GET /courses/{course_id}/sections/{section_id}/enrollments``.
 */
export const listMembers = <ThrowOnError extends boolean = false>(options: Options<ListMembersData, ThrowOnError>) =>
  (options.client ?? client).get<ListMembersResponses, ListMembersErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/members",
    ...options,
  })

/**
 * List Section Enrollments
 *
 * List canonical enrollment records for a specific section.
 *
 * This endpoint returns enrollment entities (user summary, role, section_id)
 * rather than member-tab projection fields. For member roster data such as
 * team assignment, permission-filtered email, and progress, use
 * ``GET /courses/{course_id}/members?section_id={section_id}``.
 */
export const listSectionEnrollments = <ThrowOnError extends boolean = false>(
  options: Options<ListSectionEnrollmentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListSectionEnrollmentsResponses, ListSectionEnrollmentsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/sections/{section_id}/enrollments",
    ...options,
  })

/**
 * Get Enrollments
 *
 * List canonical enrollment records for a course.
 *
 * This endpoint returns enrollment entities (user summary, role, section_id)
 * rather than member-tab projection fields. For member roster data such as
 * team assignment, permission-filtered email, and progress, use
 * ``GET /courses/{course_id}/members``.
 */
export const listEnrollments = <ThrowOnError extends boolean = false>(
  options: Options<ListEnrollmentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListEnrollmentsResponses, ListEnrollmentsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/enrollments",
    ...options,
  })

/**
 * Enroll User
 *
 * Enroll a user in a course.
 */
export const enrollUser = <ThrowOnError extends boolean = false>(options: Options<EnrollUserData, ThrowOnError>) =>
  (options.client ?? client).post<EnrollUserResponses, EnrollUserErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/enrollments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Bulk Unenroll Users
 *
 * Remove multiple users from a course and return the number of affected rows.
 */
export const bulkUnenrollUsers = <ThrowOnError extends boolean = false>(
  options: Options<BulkUnenrollUsersData, ThrowOnError>,
) =>
  (options.client ?? client).delete<BulkUnenrollUsersResponses, BulkUnenrollUsersErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/enrollments/bulk",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Bulk Enroll Users
 *
 * Enroll multiple users in a course and return the number of affected rows.
 */
export const bulkEnrollUsers = <ThrowOnError extends boolean = false>(
  options: Options<BulkEnrollUsersData, ThrowOnError>,
) =>
  (options.client ?? client).post<BulkEnrollUsersResponses, BulkEnrollUsersErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/enrollments/bulk",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Unenroll User
 *
 * Remove a user from a course.
 */
export const unenrollUser = <ThrowOnError extends boolean = false>(options: Options<UnenrollUserData, ThrowOnError>) =>
  (options.client ?? client).delete<UnenrollUserResponses, UnenrollUserErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/enrollments/{user_id}",
    ...options,
  })

/**
 * Update Enrollment
 *
 * Update enrollment role and/or section assignment.
 */
export const updateEnrollment = <ThrowOnError extends boolean = false>(
  options: Options<UpdateEnrollmentData, ThrowOnError>,
) =>
  (options.client ?? client).patch<UpdateEnrollmentResponses, UpdateEnrollmentErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/enrollments/{user_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Import Roster
 *
 * Import a course roster from CSV with preview (`dry_run=true`) or apply (`dry_run=false`) semantics.
 *
 * How matching works:
 * - User discriminator: each row is matched to an existing user by normalized `Email address`.
 * - The import does **not** create new users. Rows for unknown emails are skipped with `"User not found for email"`.
 *
 * Source format requirements:
 * - `moodle`:
 * - Required headers: `Email address`, `First name`, `Last name`, `Groups`.
 * - `section_id` is required because Moodle CSV does not contain a section column.
 * - `Groups` is split on the exact delimiter `", "` to derive team names.
 *
 * Import processing flow:
 * 1. Parse/validate CSV headers and row-level required values.
 * 2. De-duplicate rows by normalized email (team names are merged).
 * 3. Resolve users by email and plan per-row actions.
 * 4. Apply mutations only when `dry_run=false`.
 */
export const importRoster = <ThrowOnError extends boolean = false>(options: Options<ImportRosterData, ThrowOnError>) =>
  (options.client ?? client).post<ImportRosterResponses, ImportRosterErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/roster/import",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  })

/**
 * Export Roster
 *
 * Export student roster as CSV in the requested source format.
 */
export const exportRoster = <ThrowOnError extends boolean = false>(options: Options<ExportRosterData, ThrowOnError>) =>
  (options.client ?? client).get<ExportRosterResponses, ExportRosterErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/roster/export",
    ...options,
  })

/**
 * Export Gradebook
 *
 * Export course-wide gradebook as CSV.
 *
 * One row per student with overall and per-criterion scores for every
 * published assignment. Supports anonymization toggle.
 */
export const exportGradebook = <ThrowOnError extends boolean = false>(
  options: Options<ExportGradebookData, ThrowOnError>,
) =>
  (options.client ?? client).get<ExportGradebookResponses, ExportGradebookErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/export/gradebook",
    ...options,
  })

/**
 * List Course Published Scores
 *
 * List all published assignment score rows for a course.
 */
export const listCoursePublishedScores = <ThrowOnError extends boolean = false>(
  options: Options<ListCoursePublishedScoresData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListCoursePublishedScoresResponses, ListCoursePublishedScoresErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/published-scores",
    ...options,
  })

/**
 * Get Course Summary
 *
 * Retrieve aggregated metrics for the course dashboard.
 */
export const getCourseSummary = <ThrowOnError extends boolean = false>(
  options: Options<GetCourseSummaryData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetCourseSummaryResponses, GetCourseSummaryErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/summary",
    ...options,
  })

/**
 * Get Instructor Dashboard
 *
 * Retrieve aggregated dashboard metrics for instructor-facing views.
 */
export const getInstructorDashboard = <ThrowOnError extends boolean = false>(
  options?: Options<GetInstructorDashboardData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetInstructorDashboardResponses, GetInstructorDashboardErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/dashboard/instructor",
    ...options,
  })

/**
 * Get Student Dashboard
 *
 * Retrieve aggregated dashboard metrics for student-facing views.
 */
export const getStudentDashboard = <ThrowOnError extends boolean = false>(
  options?: Options<GetStudentDashboardData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetStudentDashboardResponses, GetStudentDashboardErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/dashboard/student",
    ...options,
  })

/**
 * List Projects
 *
 * List projects for a course.
 */
export const listProjects = <ThrowOnError extends boolean = false>(options: Options<ListProjectsData, ThrowOnError>) =>
  (options.client ?? client).get<ListProjectsResponses, ListProjectsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/projects",
    ...options,
  })

/**
 * Create Project
 *
 * Create a project within a course.
 */
export const createProject = <ThrowOnError extends boolean = false>(
  options: Options<CreateProjectData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateProjectResponses, CreateProjectErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/projects",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Delete Project
 *
 * Delete a project from a course.
 */
export const deleteProject = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProjectData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteProjectResponses, DeleteProjectErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/projects/{project_id}",
    ...options,
  })

/**
 * Get Project
 *
 * Retrieve a single project by its identifier.
 */
export const getProject = <ThrowOnError extends boolean = false>(options: Options<GetProjectData, ThrowOnError>) =>
  (options.client ?? client).get<GetProjectResponses, GetProjectErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/projects/{project_id}",
    ...options,
  })

/**
 * Update Project
 *
 * Update metadata for a project.
 */
export const updateProject = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProjectData, ThrowOnError>,
) =>
  (options.client ?? client).patch<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/projects/{project_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Get Project Review Summary
 *
 * Retrieve actor-scoped review summary metrics for a project.
 */
export const getProjectReviewSummary = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectReviewSummaryData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetProjectReviewSummaryResponses, GetProjectReviewSummaryErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/projects/{project_id}/review-summary",
    ...options,
  })

/**
 * List User Rubric Templates
 *
 * List reusable rubric templates created by a specific user.
 *
 * Deprecated: Use `GET /rubrics?created_by=<user_id>&is_template=true` instead, which supports the same functionality
 * with a more flexible filter-based approach and without requiring a user-scoped endpoint.
 *
 * @deprecated
 */
export const listUserRubricTemplates = <ThrowOnError extends boolean = false>(
  options: Options<ListUserRubricTemplatesData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListUserRubricTemplatesResponses, ListUserRubricTemplatesErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/users/{user_id}/rubric-templates",
    ...options,
  })

/**
 * List Rubric Collection
 *
 * List rubrics by course or creator using a single collection endpoint.
 */
export const listRubricsV2 = <ThrowOnError extends boolean = false>(
  options?: Options<ListRubricsV2Data, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListRubricsV2Responses, ListRubricsV2Errors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/rubrics",
    ...options,
  })

/**
 * Create Rubric
 *
 * Create a rubric, optionally binding it to a course.
 */
export const createRubricV2 = <ThrowOnError extends boolean = false>(
  options: Options<CreateRubricV2Data, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateRubricV2Responses, CreateRubricV2Errors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/rubrics",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * List Rubrics For Course
 *
 * List rubrics for a course via a deprecated endpoint; use `GET /rubrics?course_id=<id>` instead.
 *
 * @deprecated
 */
export const listRubrics = <ThrowOnError extends boolean = false>(options: Options<ListRubricsData, ThrowOnError>) =>
  (options.client ?? client).get<ListRubricsResponses, ListRubricsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/rubrics",
    ...options,
  })

/**
 * Create Rubric For Course
 *
 * Create a course rubric via a deprecated endpoint; use `POST /rubrics` with `course_id` instead.
 *
 * @deprecated
 */
export const createRubric = <ThrowOnError extends boolean = false>(options: Options<CreateRubricData, ThrowOnError>) =>
  (options.client ?? client).post<CreateRubricResponses, CreateRubricErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/rubrics",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Delete Rubric
 *
 * Delete a rubric permanently.
 */
export const deleteRubric = <ThrowOnError extends boolean = false>(options: Options<DeleteRubricData, ThrowOnError>) =>
  (options.client ?? client).delete<DeleteRubricResponses, DeleteRubricErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/rubrics/{rubric_id}",
    ...options,
  })

/**
 * Get Rubric
 *
 * Retrieve detailed information for a rubric.
 */
export const getRubric = <ThrowOnError extends boolean = false>(options: Options<GetRubricData, ThrowOnError>) =>
  (options.client ?? client).get<GetRubricResponses, GetRubricErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/rubrics/{rubric_id}",
    ...options,
  })

/**
 * Update Rubric
 *
 * Apply partial updates to a rubric.
 */
export const updateRubric = <ThrowOnError extends boolean = false>(options: Options<UpdateRubricData, ThrowOnError>) =>
  (options.client ?? client).patch<UpdateRubricResponses, UpdateRubricErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/rubrics/{rubric_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Replace Rubric
 *
 * Replace entire rubric structure atomically.
 *
 * This endpoint performs a full replacement of rubric metadata and nested structure in
 * one transaction. The request body is treated as the new source of truth for the rubric:
 * - Items/options with IDs that exist are updated in place
 * - Items/options with IDs that don't exist raise an error
 * - Items/options without IDs are created
 * - Items/options not in the request are deleted
 *
 * Use this endpoint when a client edits the complete rubric in memory and wants to persist
 * it as a single operation (for example, after drag-and-drop reordering and bulk edits).
 * Include all desired items/options with explicit `sort_order` values to control final order.
 * If any nested validation or lookup fails (invalid config, unknown item/option IDs, duplicate
 * slugs), no partial changes are committed.
 */
export const replaceRubric = <ThrowOnError extends boolean = false>(
  options: Options<ReplaceRubricData, ThrowOnError>,
) =>
  (options.client ?? client).put<ReplaceRubricResponses, ReplaceRubricErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/rubrics/{rubric_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * List Rubric Items
 *
 * List items for a rubric.
 */
export const listRubricItems = <ThrowOnError extends boolean = false>(
  options: Options<ListRubricItemsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListRubricItemsResponses, ListRubricItemsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/rubrics/{rubric_id}/items",
    ...options,
  })

/**
 * Create Rubric Item
 *
 * Add a new item to a rubric.
 */
export const createRubricItem = <ThrowOnError extends boolean = false>(
  options: Options<CreateRubricItemData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateRubricItemResponses, CreateRubricItemErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/rubrics/{rubric_id}/items",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Delete Rubric Item
 *
 * Remove an item from a rubric.
 */
export const deleteRubricItem = <ThrowOnError extends boolean = false>(
  options: Options<DeleteRubricItemData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteRubricItemResponses, DeleteRubricItemErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/rubrics/{rubric_id}/items/{item_id}",
    ...options,
  })

/**
 * Update Rubric Item
 *
 * Update a rubric item.
 */
export const updateRubricItem = <ThrowOnError extends boolean = false>(
  options: Options<UpdateRubricItemData, ThrowOnError>,
) =>
  (options.client ?? client).patch<UpdateRubricItemResponses, UpdateRubricItemErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/rubrics/{rubric_id}/items/{item_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Reorder Rubric Items
 *
 * Reorder rubric items.
 */
export const reorderRubricItems = <ThrowOnError extends boolean = false>(
  options: Options<ReorderRubricItemsData, ThrowOnError>,
) =>
  (options.client ?? client).post<ReorderRubricItemsResponses, ReorderRubricItemsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/rubrics/{rubric_id}/items/reorder",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * List Rubric Item Options
 *
 * List options for a rubric item.
 */
export const listRubricItemOptions = <ThrowOnError extends boolean = false>(
  options: Options<ListRubricItemOptionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListRubricItemOptionsResponses, ListRubricItemOptionsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/rubrics/{rubric_id}/items/{item_id}/options",
    ...options,
  })

/**
 * Create Rubric Item Option
 *
 * Add an option to a rubric item.
 */
export const createRubricItemOption = <ThrowOnError extends boolean = false>(
  options: Options<CreateRubricItemOptionData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateRubricItemOptionResponses, CreateRubricItemOptionErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/rubrics/{rubric_id}/items/{item_id}/options",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Delete Rubric Item Option
 *
 * Remove an option from a rubric item.
 */
export const deleteRubricItemOption = <ThrowOnError extends boolean = false>(
  options: Options<DeleteRubricItemOptionData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteRubricItemOptionResponses, DeleteRubricItemOptionErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/rubrics/{rubric_id}/options/{option_id}",
    ...options,
  })

/**
 * Update Rubric Item Option
 *
 * Update a rubric item option.
 *
 * Note: Returns 400 instead of 404 when option is not found because the domain raises
 * undifferentiable ValueError for both validation errors and missing options.
 */
export const updateRubricItemOption = <ThrowOnError extends boolean = false>(
  options: Options<UpdateRubricItemOptionData, ThrowOnError>,
) =>
  (options.client ?? client).patch<UpdateRubricItemOptionResponses, UpdateRubricItemOptionErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/rubrics/{rubric_id}/options/{option_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Reorder Rubric Item Options
 *
 * Reorder options for a rubric item.
 */
export const reorderRubricItemOptions = <ThrowOnError extends boolean = false>(
  options: Options<ReorderRubricItemOptionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<ReorderRubricItemOptionsResponses, ReorderRubricItemOptionsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/rubrics/{rubric_id}/items/{item_id}/options/reorder",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * List Assignments
 *
 * List all assignments for a course, including their current state and aggregate counts.
 */
export const listAssignments = <ThrowOnError extends boolean = false>(
  options: Options<ListAssignmentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListAssignmentsResponses, ListAssignmentsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/assignments",
    ...options,
  })

/**
 * Create Assignment
 *
 * Create a new assignment for a course with specified metadata and scheduling.
 */
export const createAssignment = <ThrowOnError extends boolean = false>(
  options: Options<CreateAssignmentData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateAssignmentResponses, CreateAssignmentErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/courses/{course_id}/assignments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Delete Assignment
 *
 * Delete an assignment and all associated allocations, reviews, and drafts.
 */
export const deleteAssignment = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAssignmentData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteAssignmentResponses, DeleteAssignmentErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}",
    ...options,
  })

/**
 * Get Assignment
 *
 * Retrieve detailed information for an assignment.
 *
 * This endpoint returns the full assignment aggregate, which may expose unnecessary data.
 * For most cases, use role-specific drill-in endpoints like /my-allocations, /my-received-reviews, or /my-written-reviews instead.
 */
export const getAssignment = <ThrowOnError extends boolean = false>(
  options: Options<GetAssignmentData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetAssignmentResponses, GetAssignmentErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}",
    ...options,
  })

/**
 * Update Assignment
 *
 * Update assignment metadata such as title, deadlines, and late submission policies.
 */
export const updateAssignment = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAssignmentData, ThrowOnError>,
) =>
  (options.client ?? client).patch<UpdateAssignmentResponses, UpdateAssignmentErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Get Assignment Summary
 *
 * Retrieve a lightweight assignment summary with aggregate counts.
 */
export const getAssignmentSummary = <ThrowOnError extends boolean = false>(
  options: Options<GetAssignmentSummaryData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetAssignmentSummaryResponses, GetAssignmentSummaryErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/summary",
    ...options,
  })

/**
 * List Allocations
 *
 * Get allocations for an assignment with role-based scoping.
 */
export const listAllocations = <ThrowOnError extends boolean = false>(
  options: Options<ListAllocationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListAllocationsResponses, ListAllocationsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/allocations",
    ...options,
  })

/**
 * Open Assignment
 *
 * Open an assignment by snapshotting rubric and generating allocations.
 */
export const openAssignment = <ThrowOnError extends boolean = false>(
  options: Options<OpenAssignmentData, ThrowOnError>,
) =>
  (options.client ?? client).post<OpenAssignmentResponses, OpenAssignmentErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/open",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Close Assignment
 *
 * Close an assignment via semantic close hook.
 */
export const closeAssignment = <ThrowOnError extends boolean = false>(
  options: Options<CloseAssignmentData, ThrowOnError>,
) =>
  (options.client ?? client).post<CloseAssignmentResponses, CloseAssignmentErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/close",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Publish Assignment
 *
 * Publish an assignment to reveal reviews.
 */
export const publishAssignment = <ThrowOnError extends boolean = false>(
  options: Options<PublishAssignmentData, ThrowOnError>,
) =>
  (options.client ?? client).post<PublishAssignmentResponses, PublishAssignmentErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/publish",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * List My Allocations
 *
 * Get the current user's assigned allocations for review.
 */
export const listMyAllocations = <ThrowOnError extends boolean = false>(
  options: Options<ListMyAllocationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListMyAllocationsResponses, ListMyAllocationsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/my-allocations",
    ...options,
  })

/**
 * List My Received Reviews
 *
 * Get reviews received by the current user with anonymized reviewer identities.
 *
 * Returns reviews where the reviewer identity is masked with a pseudonym to
 * maintain single-blind anonymity. Authors never see the real reviewer identity.
 * If reviews are unpublished, only the total count is returned.
 */
export const listMyReceivedReviews = <ThrowOnError extends boolean = false>(
  options: Options<ListMyReceivedReviewsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListMyReceivedReviewsResponses, ListMyReceivedReviewsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/my-received-reviews",
    ...options,
  })

/**
 * List My Written Reviews
 *
 * Get reviews written by the current user.
 */
export const listMyWrittenReviews = <ThrowOnError extends boolean = false>(
  options: Options<ListMyWrittenReviewsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListMyWrittenReviewsResponses, ListMyWrittenReviewsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/my-written-reviews",
    ...options,
  })

/**
 * List Reviews
 *
 * Get all submitted reviews for an assignment (staff-only visibility).
 */
export const listReviews = <ThrowOnError extends boolean = false>(options: Options<ListReviewsData, ThrowOnError>) =>
  (options.client ?? client).get<ListReviewsResponses, ListReviewsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/reviews",
    ...options,
  })

/**
 * Get Review Draft
 *
 * Fetch a saved draft for an allocation.
 *
 * Returns the draft if it exists, or null if no draft has been saved yet.
 * Students can only access their own drafts; instructors can view all drafts.
 */
export const getReviewDraft = <ThrowOnError extends boolean = false>(
  options: Options<GetReviewDraftData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetReviewDraftResponses, GetReviewDraftErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/allocations/{allocation_id}/draft",
    ...options,
  })

/**
 * Save Review Draft
 *
 * Save a draft review for an allocation, allowing reviewers to work incrementally.
 */
export const saveReviewDraft = <ThrowOnError extends boolean = false>(
  options: Options<SaveReviewDraftData, ThrowOnError>,
) =>
  (options.client ?? client).put<SaveReviewDraftResponses, SaveReviewDraftErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/allocations/{allocation_id}/draft",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Submit Review
 *
 * Submit a finalized review for an allocation, marking it complete with timestamp.
 */
export const submitReview = <ThrowOnError extends boolean = false>(options: Options<SubmitReviewData, ThrowOnError>) =>
  (options.client ?? client).post<SubmitReviewResponses, SubmitReviewErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/allocations/{allocation_id}/submit",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Submit Staff Review
 *
 * Submit a staff-authored review for a student or team.
 */
export const submitStaffReview = <ThrowOnError extends boolean = false>(
  options: Options<SubmitStaffReviewData, ThrowOnError>,
) =>
  (options.client ?? client).post<SubmitStaffReviewResponses, SubmitStaffReviewErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/staff-reviews",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Get Scoring Config
 *
 * Return resolved assignment scoring configuration including defaults.
 */
export const getAssignmentScoringConfig = <ThrowOnError extends boolean = false>(
  options: Options<GetAssignmentScoringConfigData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetAssignmentScoringConfigResponses, GetAssignmentScoringConfigErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/scoring-config",
    ...options,
  })

/**
 * Update Scoring Config
 *
 * Update assignment scoring pipeline configuration.
 */
export const updateAssignmentScoringConfig = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAssignmentScoringConfigData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateAssignmentScoringConfigResponses,
    UpdateAssignmentScoringConfigErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/scoring-config",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Preview Scores
 *
 * Compute non-materialized preview scores for all assignment reviewees.
 */
export const previewAssignmentScores = <ThrowOnError extends boolean = false>(
  options: Options<PreviewAssignmentScoresData, ThrowOnError>,
) =>
  (options.client ?? client).get<PreviewAssignmentScoresResponses, PreviewAssignmentScoresErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/scores/preview",
    ...options,
  })

/**
 * Get Published Score For Reviewee
 *
 * Return the published materialized score for a reviewee.
 */
export const getRevieweeScore = <ThrowOnError extends boolean = false>(
  options: Options<GetRevieweeScoreData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetRevieweeScoreResponses, GetRevieweeScoreErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/reviewees/{reviewee_id}/score",
    ...options,
  })

/**
 * Get Published Score For Reviewee Team
 *
 * Return the published materialized score for a reviewee team.
 */
export const getRevieweeTeamScore = <ThrowOnError extends boolean = false>(
  options: Options<GetRevieweeTeamScoreData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetRevieweeTeamScoreResponses, GetRevieweeTeamScoreErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/reviewee-teams/{reviewee_team_id}/score",
    ...options,
  })

/**
 * Get Reviewer Participation
 *
 * Retrieve reviewer participation metrics including completion rate and review counts.
 */
export const getReviewerParticipation = <ThrowOnError extends boolean = false>(
  options: Options<GetReviewerParticipationData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetReviewerParticipationResponses, GetReviewerParticipationErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/reviewers/{reviewer_id}/participation",
    ...options,
  })

/**
 * Get Reviewer Team Participation
 *
 * Retrieve participation metrics for a reviewer team.
 */
export const getReviewerTeamParticipation = <ThrowOnError extends boolean = false>(
  options: Options<GetReviewerTeamParticipationData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetReviewerTeamParticipationResponses,
    GetReviewerTeamParticipationErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/reviewer-teams/{reviewer_team_id}/participation",
    ...options,
  })

/**
 * Assign Late Joiner
 *
 * Assign allocations for a late-joining reviewer after assignment has opened.
 */
export const assignLateJoiner = <ThrowOnError extends boolean = false>(
  options: Options<AssignLateJoinerData, ThrowOnError>,
) =>
  (options.client ?? client).post<AssignLateJoinerResponses, AssignLateJoinerErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/reviewers/late-reviewer",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Assign Late Joiner Team
 *
 * Assign allocations for a late-joining reviewer team.
 */
export const assignLateJoinerTeam = <ThrowOnError extends boolean = false>(
  options: Options<AssignLateJoinerTeamData, ThrowOnError>,
) =>
  (options.client ?? client).post<AssignLateJoinerTeamResponses, AssignLateJoinerTeamErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/reviewer-teams/late-reviewer",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Add Late Author
 *
 * Queue a late assignment submitter for allocation handling and review assignment.
 */
export const addLateAuthor = <ThrowOnError extends boolean = false>(
  options: Options<AddLateAuthorData, ThrowOnError>,
) =>
  (options.client ?? client).post<AddLateAuthorResponses, AddLateAuthorErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/late-submitter",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Recommend Extra Targets
 *
 * Recommend extra review targets for a reviewer who has completed required reviews.
 */
export const recommendExtraTargets = <ThrowOnError extends boolean = false>(
  options: Options<RecommendExtraTargetsData, ThrowOnError>,
) =>
  (options.client ?? client).get<RecommendExtraTargetsResponses, RecommendExtraTargetsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/reviewers/{reviewer_id}/extra-targets",
    ...options,
  })

/**
 * Recommend Extra Targets For Reviewer Team
 *
 * Recommend extra review targets for a reviewer team.
 */
export const recommendExtraTargetsForReviewerTeam = <ThrowOnError extends boolean = false>(
  options: Options<RecommendExtraTargetsForReviewerTeamData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    RecommendExtraTargetsForReviewerTeamResponses,
    RecommendExtraTargetsForReviewerTeamErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/reviewer-teams/{reviewer_team_id}/extra-targets",
    ...options,
  })

/**
 * List Published Scores
 *
 * Return published scores keyed by reviewee principal.
 *
 * For inter-team assignments the key is the reviewee team ID;
 * for other review types the key is the reviewee user ID.
 */
export const listPublishedAssignmentScores = <ThrowOnError extends boolean = false>(
  options: Options<ListPublishedAssignmentScoresData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListPublishedAssignmentScoresResponses,
    ListPublishedAssignmentScoresErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/published-scores",
    ...options,
  })

/**
 * Get Published Score
 *
 * Get one materialized published score row for an assignment user.
 */
export const getPublishedAssignmentScore = <ThrowOnError extends boolean = false>(
  options: Options<GetPublishedAssignmentScoreData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetPublishedAssignmentScoreResponses, GetPublishedAssignmentScoreErrors, ThrowOnError>(
    {
      security: [
        { name: "x-api-key", type: "apiKey" },
        { scheme: "bearer", type: "http" },
      ],
      url: "/assignments/{assignment_id}/published-scores/{user_id}",
      ...options,
    },
  )

/**
 * Get My Score
 *
 * Get the current student's materialized published score for an assignment.
 */
export const getMyPublishedAssignmentScore = <ThrowOnError extends boolean = false>(
  options: Options<GetMyPublishedAssignmentScoreData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetMyPublishedAssignmentScoreResponses,
    GetMyPublishedAssignmentScoreErrors,
    ThrowOnError
  >({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/my-score",
    ...options,
  })

/**
 * Export Scores
 *
 * Export assignment scores as CSV.
 *
 * Generates a CSV with per-student gradebook data including per-criterion means,
 * overall scores, and review counts. Supports anonymization toggle.
 */
export const exportAssignmentScores = <ThrowOnError extends boolean = false>(
  options: Options<ExportAssignmentScoresData, ThrowOnError>,
) =>
  (options.client ?? client).get<ExportAssignmentScoresResponses, ExportAssignmentScoresErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/export/scores",
    ...options,
  })

/**
 * Export Reviews
 *
 * Export assignment reviews as CSV with normalized rubric-item columns.
 *
 * One row per allocation (including allocations without a submitted review).
 * Rubric answers are expanded into individual columns instead of JSON blobs.
 * Supports anonymization toggle with reviewer pseudonyms.
 */
export const exportAssignmentReviews = <ThrowOnError extends boolean = false>(
  options: Options<ExportAssignmentReviewsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ExportAssignmentReviewsResponses, ExportAssignmentReviewsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/export/reviews",
    ...options,
  })

/**
 * Export Allocations
 *
 * Export assignment allocations as CSV.
 *
 * .. deprecated::
 * Use the reviews export instead, which now includes all allocations
 * with normalized rubric-item answer columns.
 *
 * @deprecated
 */
export const exportAssignmentAllocations = <ThrowOnError extends boolean = false>(
  options: Options<ExportAssignmentAllocationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ExportAssignmentAllocationsResponses, ExportAssignmentAllocationsErrors, ThrowOnError>(
    {
      security: [
        { name: "x-api-key", type: "apiKey" },
        { scheme: "bearer", type: "http" },
      ],
      url: "/assignments/{assignment_id}/export/allocations",
      ...options,
    },
  )

/**
 * List Team Allocations
 *
 * List all inter-team allocations for an assignment (staff only).
 */
export const listTeamAllocations = <ThrowOnError extends boolean = false>(
  options: Options<ListTeamAllocationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListTeamAllocationsResponses, ListTeamAllocationsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/team-allocations",
    ...options,
  })

/**
 * Release Team Review Lock
 *
 * Release the edit lock on a team review.
 */
export const releaseTeamReviewLock = <ThrowOnError extends boolean = false>(
  options: Options<ReleaseTeamReviewLockData, ThrowOnError>,
) =>
  (options.client ?? client).delete<ReleaseTeamReviewLockResponses, ReleaseTeamReviewLockErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/team-allocations/{allocation_id}/lock",
    ...options,
  })

/**
 * Acquire Team Review Lock
 *
 * Acquire the edit lock on a team review.
 */
export const acquireTeamReviewLock = <ThrowOnError extends boolean = false>(
  options: Options<AcquireTeamReviewLockData, ThrowOnError>,
) =>
  (options.client ?? client).post<AcquireTeamReviewLockResponses, AcquireTeamReviewLockErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/team-allocations/{allocation_id}/lock",
    ...options,
  })

/**
 * Save Team Review Draft
 *
 * Save a draft for a team review. Requires the edit lock.
 */
export const saveTeamReviewDraft = <ThrowOnError extends boolean = false>(
  options: Options<SaveTeamReviewDraftData, ThrowOnError>,
) =>
  (options.client ?? client).put<SaveTeamReviewDraftResponses, SaveTeamReviewDraftErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/team-allocations/{allocation_id}/draft",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Submit Team Review
 *
 * Submit a team review.
 */
export const submitTeamReview = <ThrowOnError extends boolean = false>(
  options: Options<SubmitTeamReviewData, ThrowOnError>,
) =>
  (options.client ?? client).post<SubmitTeamReviewResponses, SubmitTeamReviewErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/team-allocations/{allocation_id}/submit",
    ...options,
  })

/**
 * Unsubmit Team Review
 *
 * Revert a submitted team review to draft state.
 */
export const unsubmitTeamReview = <ThrowOnError extends boolean = false>(
  options: Options<UnsubmitTeamReviewData, ThrowOnError>,
) =>
  (options.client ?? client).post<UnsubmitTeamReviewResponses, UnsubmitTeamReviewErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/assignments/{assignment_id}/team-allocations/{allocation_id}/unsubmit",
    ...options,
  })

/**
 * Enroll Mock Students
 *
 * Enroll configured mock students into a course (admin-only).
 */
export const adminEnrollMockStudents = <ThrowOnError extends boolean = false>(
  options: Options<AdminEnrollMockStudentsData, ThrowOnError>,
) =>
  (options.client ?? client).post<AdminEnrollMockStudentsResponses, AdminEnrollMockStudentsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/admin/courses/{course_id}/enroll-mock-students",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * List Issuers
 *
 * List all LTI issuers.
 */
export const listLtiIssuers = <ThrowOnError extends boolean = false>(
  options?: Options<ListLtiIssuersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListLtiIssuersResponses, ListLtiIssuersErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/admin/lti/issuers",
    ...options,
  })

/**
 * Create Issuer
 *
 * Create a new LTI issuer.
 */
export const createLtiIssuer = <ThrowOnError extends boolean = false>(
  options: Options<CreateLtiIssuerData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateLtiIssuerResponses, CreateLtiIssuerErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/admin/lti/issuers",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Delete Issuer
 *
 * Delete an LTI issuer.
 */
export const deleteLtiIssuer = <ThrowOnError extends boolean = false>(
  options: Options<DeleteLtiIssuerData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteLtiIssuerResponses, DeleteLtiIssuerErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/admin/lti/issuers/{issuer_id}",
    ...options,
  })

/**
 * Get Issuer
 *
 * Get an LTI issuer by ID.
 */
export const getLtiIssuer = <ThrowOnError extends boolean = false>(options: Options<GetLtiIssuerData, ThrowOnError>) =>
  (options.client ?? client).get<GetLtiIssuerResponses, GetLtiIssuerErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/admin/lti/issuers/{issuer_id}",
    ...options,
  })

/**
 * Update Issuer
 *
 * Update an LTI issuer.
 */
export const updateLtiIssuer = <ThrowOnError extends boolean = false>(
  options: Options<UpdateLtiIssuerData, ThrowOnError>,
) =>
  (options.client ?? client).patch<UpdateLtiIssuerResponses, UpdateLtiIssuerErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/admin/lti/issuers/{issuer_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * List Client Configs
 *
 * List all client configurations for an issuer.
 */
export const listLtiClientConfigs = <ThrowOnError extends boolean = false>(
  options: Options<ListLtiClientConfigsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListLtiClientConfigsResponses, ListLtiClientConfigsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/admin/lti/issuers/{issuer_id}/client-configs",
    ...options,
  })

/**
 * Create Client Config
 *
 * Create a new client configuration for an issuer.
 */
export const createLtiClientConfig = <ThrowOnError extends boolean = false>(
  options: Options<CreateLtiClientConfigData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateLtiClientConfigResponses, CreateLtiClientConfigErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/admin/lti/issuers/{issuer_id}/client-configs",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Delete Client Config
 *
 * Delete a client configuration.
 */
export const deleteLtiClientConfig = <ThrowOnError extends boolean = false>(
  options: Options<DeleteLtiClientConfigData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteLtiClientConfigResponses, DeleteLtiClientConfigErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/admin/lti/client-configs/{client_config_id}",
    ...options,
  })

/**
 * Get Client Config
 *
 * Get a client configuration by ID.
 */
export const getLtiClientConfig = <ThrowOnError extends boolean = false>(
  options: Options<GetLtiClientConfigData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetLtiClientConfigResponses, GetLtiClientConfigErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/admin/lti/client-configs/{client_config_id}",
    ...options,
  })

/**
 * Update Client Config
 *
 * Update a client configuration.
 */
export const updateLtiClientConfig = <ThrowOnError extends boolean = false>(
  options: Options<UpdateLtiClientConfigData, ThrowOnError>,
) =>
  (options.client ?? client).patch<UpdateLtiClientConfigResponses, UpdateLtiClientConfigErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/admin/lti/client-configs/{client_config_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * List Deployments
 *
 * List all deployments for a client configuration.
 */
export const listLtiDeployments = <ThrowOnError extends boolean = false>(
  options: Options<ListLtiDeploymentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListLtiDeploymentsResponses, ListLtiDeploymentsErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/admin/lti/client-configs/{client_config_id}/deployments",
    ...options,
  })

/**
 * Add Deployment
 *
 * Add a deployment to a client configuration.
 */
export const addLtiDeployment = <ThrowOnError extends boolean = false>(
  options: Options<AddLtiDeploymentData, ThrowOnError>,
) =>
  (options.client ?? client).post<AddLtiDeploymentResponses, AddLtiDeploymentErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/admin/lti/client-configs/{client_config_id}/deployments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Remove Deployment
 *
 * Remove a deployment.
 */
export const removeLtiDeployment = <ThrowOnError extends boolean = false>(
  options: Options<RemoveLtiDeploymentData, ThrowOnError>,
) =>
  (options.client ?? client).delete<RemoveLtiDeploymentResponses, RemoveLtiDeploymentErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/admin/lti/deployments/{deployment_id}",
    ...options,
  })

/**
 * List Tool Keys
 *
 * List all LTI tool keys.
 */
export const listLtiToolKeys = <ThrowOnError extends boolean = false>(
  options?: Options<ListLtiToolKeysData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListLtiToolKeysResponses, ListLtiToolKeysErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/admin/lti/tool-keys/",
    ...options,
  })

/**
 * Create Tool Key
 *
 * Create a new LTI tool key.
 */
export const createLtiToolKey = <ThrowOnError extends boolean = false>(
  options: Options<CreateLtiToolKeyData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateLtiToolKeyResponses, CreateLtiToolKeyErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/admin/lti/tool-keys/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

/**
 * Delete Tool Key
 *
 * Delete an LTI tool key.
 */
export const deleteLtiToolKey = <ThrowOnError extends boolean = false>(
  options: Options<DeleteLtiToolKeyData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteLtiToolKeyResponses, DeleteLtiToolKeyErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/admin/lti/tool-keys/{key_id}",
    ...options,
  })

/**
 * Get Tool Key
 *
 * Get an LTI tool key by ID.
 */
export const getLtiToolKey = <ThrowOnError extends boolean = false>(
  options: Options<GetLtiToolKeyData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetLtiToolKeyResponses, GetLtiToolKeyErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/admin/lti/tool-keys/{key_id}",
    ...options,
  })

/**
 * Update Tool Key
 *
 * Update an LTI tool key.
 */
export const updateLtiToolKey = <ThrowOnError extends boolean = false>(
  options: Options<UpdateLtiToolKeyData, ThrowOnError>,
) =>
  (options.client ?? client).patch<UpdateLtiToolKeyResponses, UpdateLtiToolKeyErrors, ThrowOnError>({
    security: [
      { name: "x-api-key", type: "apiKey" },
      { scheme: "bearer", type: "http" },
    ],
    url: "/admin/lti/tool-keys/{key_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })
